const oldHost = 'imagedelivery.net';
const newHost = 'img.gumtree.com';

function javaStringHashCode(str: string) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = (hash * 31 + str.charCodeAt(i)) | 0;
    }
    return hash;
}

function isInRollout(imageUrl: string, ROLLOUT_PERCENTAGE: number) {
    const hash = javaStringHashCode(imageUrl);

    const positive31 = hash & 0x7fffffff;

    return positive31 % 100 < ROLLOUT_PERCENTAGE;
}

const ROLLOUT_PERCENTAGE = 100;

export const grayCalc = (path: string) => {
    const url = new URL(path);
    if (url.hostname !== oldHost) {
        return false;
    }

    const javaString = url.pathname.split('/').reverse()[1];
    return isInRollout(javaString, ROLLOUT_PERCENTAGE);
};

export const isInHost = (path: string) => {
    const url = new URL(path);
    const whiteHost = [newHost, oldHost, location.hostname];
    return whiteHost.includes(url.hostname);
};
